import { motion } from "framer-motion";
import CtaButton from "./CtaButton";
import blkLogo from "@/assets/Blk_Logo.webp";

const Contact = () => {
  return (
    <section id="contact-us" className="bg-primary py-20 md:py-28 px-6 scroll-mt-24">
      <div className="mx-auto max-w-3xl text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <img
            src={blkLogo}
            alt="Love Otherwise"
            width={640}
            height={640}
            loading="lazy"
            className="w-48 h-auto mx-auto mb-8 brightness-0 invert"
          />
          <span className="text-xs tracking-[0.3em] uppercase text-primary-foreground/70 font-body">Get in Touch</span>
          <h2 className="mt-4 text-3xl md:text-5xl font-display font-light text-primary-foreground leading-snug">
            The setting is curated.<br />
            <span className="italic">The story is yours.</span>
          </h2>
          <div className="mx-auto mt-6 h-px w-12 bg-champagne" />
          <p className="mt-6 text-base font-body font-light text-primary-foreground/80">
            Let us make this day easy and beautiful for you.
          </p>
          <div className="mt-10 flex justify-center">
            <CtaButton href="/contact" variant="outline" onDarkBg>
              Contact Us
            </CtaButton>
          </div>
          <p className="mt-12 text-xs tracking-[0.3em] uppercase font-body text-primary-foreground/70">
            London · Ontario · Canada
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
